import { styled } from '@mui/material';
import { PADDING, SIZES } from '../../../constants/sizes';
import { Flex } from '../../base/Flex';
import { Text } from '../../base/Text';
import { Button } from '../../base/Button';
import PopoverBox from '../PopoverBox';
import { colorPalettes } from '../../../context/theme';

export const StyledPopover = styled(PopoverBox)`
  width: 26rem;
  padding: ${PADDING['x-large']};
  font-size: ${SIZES['small']};
  box-sizing: border-box;
`;

export const StyledPopoverElement = styled.div`
  width: 23rem;
  padding: ${({ firstElement }) =>
    firstElement
      ? `${PADDING['medium']} 0 ${PADDING['x-x-x-large']} 0`
      : `${PADDING['x-x-x-large']} 0`};
  font-size: ${SIZES['small']};
  box-sizing: border-box;
  ${({ firstElement, theme }) =>
    !firstElement &&
    `border-top: 1px solid ${
      colorPalettes[theme.palette.mode].background.secondary
    };`}
`;

export const StyledHeader = styled(Flex)``;

export const StyledHeaderIcon = styled.span`
  padding-right: ${PADDING['medium']};
`;

export const StyledContent = styled(Text)`
  color: ${({ theme }) => colorPalettes[theme.palette.mode].text.primary};
  font-size: ${SIZES['small']};
  padding: ${PADDING['medium']} 0 ${PADDING['x-large']};
`;

export const StyledCTA = styled(Button)`
  color: ${({ theme }) =>
    colorPalettes[theme.palette.mode].button.secondary.text.active};
  border: 1px solid
    ${({ theme }) =>
      colorPalettes[theme.palette.mode].button.secondary.stroke.active};
  font-size: ${SIZES['small']};
`;
